module.exports = __webpack_public_path__ + "static/media/avatar-white.1ecc9c22.svg";